import sortBy from 'lodash/sortBy';

import {
  FBI_FETCH_ALL_AGENTS_START,
  FBI_FETCH_ALL_AGENTS_SUCCESS,
  FBI_FETCH_ALL_AGENTS_FAILURE,
  FBI_EDIT_NODE_END,
} from '../../actions/flowBlockInput';

export const INITIAL_STATE = {
  xagents: [],
  selectedAgents: [],
};

export function sortAgents(a, b) {
  let result = 0;
  if (a.status > b.status) {
    result = 1;
  } else if (a.status < b.status) {
    result = -1;
  }
  if (result !== 0) {
    return result;
  }
  if (a.name > b.name) {
    result = 1;
  } else if (a.name < b.name) {
    result = -1;
  }
  return result;
}

export default function runLocationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FBI_FETCH_ALL_AGENTS_START:
      return {
        ...state,
      };
    case FBI_FETCH_ALL_AGENTS_SUCCESS:
      if (typeof action.payload.data !== 'undefined') {
        const sortedData = sortBy(action.payload.data, ['status', 'name']);
        return {
          ...state,
          xagents: sortedData,
        };
      }
      return {
        ...state,
        xagents: [],
      };
    case FBI_FETCH_ALL_AGENTS_FAILURE:
      return {
        ...state,
      };
    case FBI_EDIT_NODE_END:
      return INITIAL_STATE;
    default:
      return state;
  }
}
